import { render, staticRenderFns } from "./RawExport.vue?vue&type=template&id=15a5abf0&scoped=true&"
import script from "./RawExport.vue?vue&type=script&lang=js&"
export * from "./RawExport.vue?vue&type=script&lang=js&"
import style0 from "./RawExport.vue?vue&type=style&index=0&id=15a5abf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a5abf0",
  null
  
)

/* custom blocks */
import block0 from "./RawExport.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15a5abf0')) {
      api.createRecord('15a5abf0', component.options)
    } else {
      api.reload('15a5abf0', component.options)
    }
    module.hot.accept("./RawExport.vue?vue&type=template&id=15a5abf0&scoped=true&", function () {
      api.rerender('15a5abf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/RawExport.vue"
export default component.exports